import { ReactNode } from 'react'
import styles from '../styles.module.css'
import TextField from '@mui/material/TextField'
import MenuItem from '@mui/material/MenuItem'
import CircularProgress from '@mui/material/CircularProgress'
import { IVehicleInformationSelectProps } from '../VehicleInformationForm'
import useFetch from '../../../../../../../global/hooks/useFetchHook'
import { getBrandYears } from '../../api'

const selectProps = {
  MenuProps: {
    PaperProps: {
      style: {
        maxHeight: 500,
        width: 250,
      },
    },
  },
}

export default function YearInformationSelect(
  props: IVehicleInformationSelectProps,
) {
  const { formData, setFormData, label } = props

  let menuItems = [] as ReactNode

  let { data, isLoading, error } = useFetch<string[]>(
    getBrandYears(formData.brandName),
  )

  if (data) {
    menuItems = data.map((item: string) => {
      return (
        <MenuItem
          key={item}
          value={item}
        >
          {item}
        </MenuItem>
      )
    })
  } else if (error) {
    menuItems = [<MenuItem value={'2010'}>Error - No years available</MenuItem>]
  }

  if (isLoading) {
    return <CircularProgress size={20} />
  }

  return (
    <TextField
      className={styles.textfieldStyles}
      label={label}
      value={formData.year}
      name='vehicleYear'
      select
      SelectProps={selectProps}
      onChange={(e) =>
        setFormData({
          ...formData,
          year: e.target.value,
          model: '',
          variant: '',
        })
      }
    >
      {menuItems}
    </TextField>
  )
}
